import React from 'react';
import { PageContentLayout } from '@/finsight/ui/common/components/ContentLayouts';
import LeagueLists from '@/finsight/ui/components/league/LeagueTablePage';
import getServerSideTopCompanies from '@/finsight/application/League/serverSide/getServerSideTopCompanies';
import LeagueTableContextProvider from '@/finsight/application/League/Table/LeagueTableContext';
import withLeagueTableProps from '@/finsight/application/League/Table/withLeagueTableProps';
import { TypeCompany } from '@/finsight/application/League/constants';
import {
  ICompaniesAllState,
  IRatingAgenciesState,
  ITopRatingAgenciesState,
  ITopUnderwritersState,
  IUnderwritersState,
} from '@/finsight/application/League/interfaces';
import { getTtmFilterInitialState } from '@/finsight/application/League/helpers';
import getServerSideCompanies from '@/finsight/application/League/serverSide/getServerSideCompanies';
import LeagueTableFilterContextProvider from '@/finsight/application/League/Table/LeagueTableFiltersContext';
import getServerSideLeagueTablesBreadcrumbs
  from '@/finsight/application/Breadcrumbs/serverSide/getServerSideLeagueTablesBreadcrumbs';
import IBreadcrumb from '@/finsight/domain/vo/Breadcrumbs';
import PageFiltersContextProvider from '@/finsight/application/PageFilters/PageFiltersContext';

export const getServerSideProps = withLeagueTableProps(async (context) => {
  const [
    topUnderwritersState,
    topRatingAgenciesState,
    underwritersState,
    ratingAgenciesState,
    companiesAllState,
    breadcrumbs,
  ]:[
    ITopUnderwritersState,
    ITopRatingAgenciesState,
    IUnderwritersState,
    IRatingAgenciesState,
    ICompaniesAllState,
    IBreadcrumb[],
  ] = await Promise.all([
    getServerSideTopCompanies(TypeCompany.underwriter)(context),
    getServerSideTopCompanies(TypeCompany.ratingAgency)(context),
    getServerSideCompanies(TypeCompany.underwriter)(context),
    getServerSideCompanies(TypeCompany.ratingAgency)(context),
    getServerSideCompanies(TypeCompany.all)(context),
    getServerSideLeagueTablesBreadcrumbs(context),
  ]);
  return ({
    props: {
      topUnderwritersState,
      topRatingAgenciesState,
      underwritersState,
      ratingAgenciesState,
      companiesAllState,
      breadcrumbs,
    },
  });
});

const LeagueTable = () => (
  <PageContentLayout>
    <LeagueLists />
  </PageContentLayout>
);

export default (props) => {
  const {
    topUnderwritersState,
    topRatingAgenciesState,
    searchText,
    topUnderwritersTtmFilter,
    topRatingAgencyTtmFilter,
    companiesTtmFilter,
    underwritersState,
    ratingAgenciesState,
    companiesAllState,
  } = props;
  const ttmFilterInitState = {
    leagueTable: getTtmFilterInitialState(companiesTtmFilter),
    topUnderwriters: getTtmFilterInitialState(topUnderwritersTtmFilter),
    topRatingAgencies: getTtmFilterInitialState(topRatingAgencyTtmFilter),
  };

  return (
    <PageFiltersContextProvider>
      <LeagueTableFilterContextProvider
        searchText={ searchText }
        ttmFilterInitState={ ttmFilterInitState }
      >
        <LeagueTableContextProvider
          topUnderwritersInitialState={ topUnderwritersState }
          topRatingAgenciesInitialState={ topRatingAgenciesState }
          underwritersInitialState={ underwritersState }
          ratingAgenciesInitialState={ ratingAgenciesState }
          companiesAllInitialState={ companiesAllState }
        >
          <LeagueTable />
        </LeagueTableContextProvider>
      </LeagueTableFilterContextProvider>
    </PageFiltersContextProvider>
  );
};
